interface DefaultVoice {
  id: string
  name: string
  clip_url: string
  provider: string
  supported_locales?: Array<string>
}

export const defaultVoices: DefaultVoice[] = [
  {
    id: "iP95p4xoKVk53GoZ742B",
    name: "Chris (Premium+, any language, male)",
    clip_url: "/audio/chris.mp3",
    provider: "elevenlabs"
  },
  {
    id: "mkrzc6Zmz8alRK0wX5dd",
    name: "Charlie (Premium+, any language, male)",
    clip_url: "/audio/charlie.mp3",
    provider: "elevenlabs"
  },
  {
    id: "cgSgspJ2msm6clMCkdW9",
    name: "Jessica (Premium+, any language, female)",
    clip_url: "/audio/jessica.mp3",
    provider: "elevenlabs"
  },
  {
    id: "ErXwobaYiN019PkySvjV",
    name: "Antoni (Premium, any language, male)",
    clip_url: "/audio/antoni.mp3",
    provider: "elevenlabs"
  },
  {
    id: "TxGEqnHWrfWFTfGW9XjX",
    name: "Josh (Premium, any language, male)",
    clip_url: "/audio/josh.mp3",
    provider: "elevenlabs"
  },
  {
    id: "21m00Tcm4TlvDq8ikWAM",
    name: "Rachel (Premium, any language, female)",
    clip_url: "/audio/rachel.mp3",
    provider: "elevenlabs"
  },
  {
    id: "XrExE9yKIg1WjnnlVkGX",
    name: "Matilda (Premium, any language, female)",
    clip_url: "/audio/matilda.mp3",
    provider: "elevenlabs"
  },
  {
    id: "en-US-Neural2-I",
    name: "Peyton (basic, English, male)",
    clip_url: "/audio/peyton.mp3",
    supported_locales: ["en-us"],
    provider: "gcp"
  },
  {
    id: "en-US-Neural2-E",
    name: "Gertrude (basic, English, female)",
    clip_url: "/audio/gertrude.mp3",
    supported_locales: ["en-us"],
    provider: "gcp"
  },
  // {
  //   id: "en-GB-Neural2-A",
  //   name: "Sophia (British English) (female)",
  //   clip_url: "/audio/sophia.mp3",
  //   supported_locales: ["en-us"]
  // },
  // {
  //   id: "en-GB-Neural2-B",
  //   name: "Oliver (British English) (male)",
  //   clip_url: "/audio/oliver.mp3",
  //   supported_locales: ["en-us"]
  // },
  // {
  //   id: "fr-CA-Neural2-A",
  //   name: "Élise (Canadian French) (female)",
  //   clip_url: "/audio/elise.mp3",
  //   supported_locales: ["fr-fr"]
  // },
  // {
  //   id: "fr-CA-Neural2-B",
  //   name: "Jean (Canadian French) (male)",
  //   clip_url: "/audio/jean.mp3",
  //   supported_locales: ["fr-fr"]
  // },
  {
    id: "da-DK-Wavenet-A",
    name: "Kirsten (basic, Danish, female)",
    clip_url: "/audio/kirsten.mp3",
    supported_locales: ["da-dk"],
    provider: "gcp"
  },
  {
    id: "da-DK-Wavenet-C",
    name: "Mikkel (basic, Danish, male)",
    clip_url: "/audio/mikkel.mp3",
    supported_locales: ["da-dk"],
    provider: "gcp"
  },
  {
    id: "nl-NL-Wavenet-A",
    name: "Sanne (basic, Dutch, female)",
    clip_url: "/audio/sanne.mp3",
    supported_locales: ["nl-nl"],
    provider: "gcp"
  },
  {
    id: "nl-NL-Wavenet-B",
    name: "Daan (basic, Dutch, male)",
    clip_url: "/audio/daan.mp3",
    supported_locales: ["nl-nl"],
    provider: "gcp"
  },
  {
    id: "fr-FR-Neural2-A",
    name: "Camille (basic, French, female)",
    clip_url: "/audio/camille.mp3",
    supported_locales: ["fr-fr"],
    provider: "gcp"
  },
  {
    id: "fr-FR-Neural2-B",
    name: "Louis (basic, French, male)",
    clip_url: "/audio/louis.mp3",
    supported_locales: ["fr-fr"],
    provider: "gcp"
  },
  // {
  //   id: "el-GR-Wavenet-A",
  //   name: "Nikos (Greek) (female)",
  //   clip_url: "/audio/nikos.mp3",
  //   supported_locales: ["el-gr"]
  // },
  {
    id: "de-DE-Neural2-A",
    name: "Greta (basic, German, female)",
    clip_url: "/audio/greta.mp3",
    supported_locales: ["de-de"],
    provider: "gcp"
  },
  {
    id: "de-DE-Neural2-B",
    name: "Hans (basic, German, male)",
    clip_url: "/audio/hans.mp3",
    supported_locales: ["de-de"],
    provider: "gcp"
  },
  {
    id: "hi-IN-Neural2-A",
    name: "Anaya (basic, Hindi, female)",
    clip_url: "/audio/anaya.mp3",
    supported_locales: ["hi-in"],
    provider: "gcp"
  },
  {
    id: "hi-IN-Neural2-B",
    name: "Raj (basic, Hindi, male)",
    clip_url: "/audio/raj.mp3",
    supported_locales: ["hi-in"],
    provider: "gcp"
  },
  {
    id: "id-ID-Wavenet-A",
    name: "Siti (basic, Indonesian, female)",
    clip_url: "/audio/siti.mp3",
    supported_locales: ["id-id"],
    provider: "gcp"
  },
  {
    id: "id-ID-Wavenet-B",
    name: "Rizky (basic, Indonesian, male)",
    clip_url: "/audio/rizky.mp3",
    supported_locales: ["id-id"],
    provider: "gcp"
  },
  {
    id: "it-IT-Neural2-A",
    name: "Alessia (basic, Italian, female)",
    clip_url: "/audio/alessia.mp3",
    supported_locales: ["it-it"],
    provider: "gcp"
  },
  {
    id: "it-IT-Neural2-C",
    name: "Giorgio (basic, Italian, male)",
    clip_url: "/audio/giorgio.mp3",
    supported_locales: ["it-it"],
    provider: "gcp"
  },
  {
    id: "ko-KR-Neural2-A",
    name: "Yuna (basic, Korean, female)",
    clip_url: "/audio/yuna.mp3",
    supported_locales: ["ko-kr"],
    provider: "gcp"
  },
  {
    id: "ko-KR-Neural2-C",
    name: "Joon (basic, Korean, male)",
    clip_url: "/audio/joon.mp3",
    supported_locales: ["ko-kr"],
    provider: "gcp"
  },
  {
    id: "cmn-CN-Wavenet-A",
    name: "Mei (basic, Mandarin, female)",
    clip_url: "/audio/mei.mp3",
    supported_locales: ["zh-cn"],
    provider: "gcp"
  },
  {
    id: "cmn-CN-Wavenet-B",
    name: "Liang (basic, Mandarin, male)",
    clip_url: "/audio/liang.mp3",
    supported_locales: ["zh-cn"],
    provider: "gcp"
  },
  // {
  //   id: "pl-PL-Wavenet-A",
  //   name: "Agnieszka (Polish) (female)",
  //   clip_url: "/audio/agnieszka.mp3",
  //   supported_locales: ["pl-pl"]
  // },
  // {
  //   id: "pl-PL-Wavenet-B",
  //   name: "Jan (Polish) (male)",
  //   clip_url: "/audio/jan.mp3",
  //   supported_locales: ["pl-pl"]
  // },
  {
    id: "pt-BR-Neural2-A",
    name: "Fernanda (basic, Brazilian Portuguese, female)",
    clip_url: "/audio/fernanda.mp3",
    supported_locales: ["pt-pt"],
    provider: "gcp"
  },
  {
    id: "pt-BR-Neural2-B",
    name: "Lucas (basic, Brazilian Portuguese, male)",
    clip_url: "/audio/lucas.mp3",
    supported_locales: ["pt-pt"],
    provider: "gcp"
  },
  // {
  //   id: "pt-PT-Wavenet-A",
  //   name: "Mariana (Portuguese) (female)",
  //   clip_url: "/audio/mariana.mp3",
  //   supported_locales: ["pt-pt"]
  // },
  // {
  //   id: "pt-PT-Wavenet-B",
  //   name: "Tiago (Portuguese) (male)",
  //   clip_url: "/audio/tiago.mp3",
  //   supported_locales: ["pt-pt"]
  // },
  {
    id: "es-US-Neural2-A",
    name: "Isabella (basic, US/Mexican Spanish, female)",
    clip_url: "/audio/isabella.mp3",
    supported_locales: ["es-es"],
    provider: "gcp"
  },
  {
    id: "es-US-Neural2-B",
    name: "Diego (basic, US/Mexican Spanish, male)",
    clip_url: "/audio/diego.mp3",
    supported_locales: ["es-es"],
    provider: "gcp"
  },
  // {
  //   id: "es-ES-Neural2-B",
  //   name: "Pablo (Spain Spanish) (male)",
  //   clip_url: "/audio/pablo.mp3",
  //   supported_locales: ["es-es"]
  // },
  // {
  //   id: "es-ES-Neural2-A",
  //   name: "Lisbeth (Spain Spanish) (female)",
  //   clip_url: "/audio/lisbeth.mp3",
  //   supported_locales: ["es-es"]
  // },
  {
    id: "sv-SE-Wavenet-A",
    name: "Sara (basic, Swedish, female)",
    clip_url: "/audio/sara.mp3",
    supported_locales: ["sv-se"],
    provider: "gcp"
  },
  {
    id: "sv-SE-Wavenet-C",
    name: "Erik (basic, Swedish, male)",
    clip_url: "/audio/erik.mp3",
    supported_locales: ["sv-se"],
    provider: "gcp"
  }
  // {
  //   id: "tr-TR-Wavenet-A",
  //   name: "Elif (Turkish) (female)",
  //   clip_url: "/audio/elif.mp3",
  //   supported_locales: ["tr-tr"]
  // },
  // {
  //   id: "tr-TR-Wavenet-B",
  //   name: "Deniz (Turkish) (male)",
  //   clip_url: "/audio/deniz.mp3",
  //   supported_locales: ["tr-tr"]
  // },
  // {
  //   id: "uk-UA-Wavenet-A",
  //   name: "Oles (Ukrainian) (female)",
  //   clip_url: "/audio/oles.mp3",
  //   supported_locales: ["uk-ua"]
  // }
]

export function findVoiceById(id: string): DefaultVoice | undefined {
  return defaultVoices.find((voice) => voice.id === id)
}
